import {ChangeDetectorRef, Component, ComponentFactoryResolver,} from '@angular/core';
import {ConfirmationService, MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {FieldRecord} from "../../../model/api/field-record";
import {FieldRequest} from "../../../model/api/field-request";
import {FormFieldConfig} from "../../../model/api/form-field-config";
import {CommonFieldService} from "../../../services/common/common-field.service";
import {CrudBaseComponent} from "../../../crystal-elements/crud/crud-base.component";
import {ExchangeDetail} from "../../../model/exchange/exchange-detail";
import {OwnerCode} from "../../../model/exchange/owner-code";
import {ExchangeOwnerCodeService} from "../../../services/exchange/exchange-owner-code.service";
import TYPE = FormFieldConfig.TYPE;

@Component({
  selector: 'app-owner-code',
  templateUrl: './owner-code.component.html',
  providers: [
    MessageService,
    ConfirmationService,
    TranslateService,
  ],
})
export class OwnerCodeComponent extends CrudBaseComponent<OwnerCode> {

  //fields
  owners: FieldRecord<any>[]
  ownerTypes: FieldRecord<any>[]
  ownerStates: FieldRecord<any>[]
  exchanges: FieldRecord<any>[]

  constructor(cdref: ChangeDetectorRef,
              ownerCodeService: ExchangeOwnerCodeService,
              commonFieldService: CommonFieldService,
              componentFactoryResolver: ComponentFactoryResolver,
              messageService: MessageService,
              confirmationService: ConfirmationService,
              translateService: TranslateService) {
    super(cdref, messageService, confirmationService, translateService, commonFieldService);
    this.crudService = ownerCodeService;
    this.newRecord = new OwnerCode();
    this.newRecord.exchangeCode = ExchangeDetail.ALL;
    this.prepareForClone = this.prepareRecordForClone;
  }

  prepareRecordForClone() {
    if (this.formRecord) {
      this.formRecord.id = -1;
    }
  }

  protected initConfigs() {
    super.initConfigs();

    this.tableConfig = [
      {
        field: 'exchangeCode',
        width: 150,
        mapId: record => !record.exchangeCode || record.exchangeCode === ExchangeDetail.ALL ? ExchangeDetail.ALL_TEXT : record.exchangeCode,
        icon: (record: any) => {
          const exchField = this.exchanges ? this.exchanges.find(field => field.value
            && field.value.code === record.exchangeCode) : undefined;
          if (exchField && exchField.value) {
            return exchField.value.country ? 'flag-icon flag-icon-' + exchField.value.country.toLowerCase() : '';
          } else {
            return 'fas fa-globe-europe';
          }
        }
      },
      {
        field: 'ownerName',
        width: 130,
      },
      {
        field: 'code',
        width: 100,
      },
      {
        field: 'ownerType',
        width: 100,
      },
      {
        field: 'ownerState',
        width: 100,
      },
      {
        field: 'clearingOrganization',
      }];

    this.formConfig = [
      {
        group: '',
        fields: [
          {
            field: 'ownerId',
            required: true,
            filter: true,
            column: 4,
            type: TYPE.DROPDOWN,
            options: () => this.owners
          },
          {
            field: 'exchangeCode',
            required: true,
            filter: true,
            column: 4,
            type: TYPE.DROPDOWN,
            options: () => this.exchanges,
            icon: (ig: any) => {
              const exchField = this.exchanges ? this.exchanges.find(field => field.value && field.value.code === ig) : undefined;
              if (exchField && exchField.value) {
                return exchField.value.country ? 'flag-icon flag-icon-' + exchField.value.country.toLowerCase() : '';
              } else {
                return 'fas fa-globe-europe';
              }
            },
            optionValue: 'id'
          },
          {
            field: 'code',
            column: 4,
            type: TYPE.TEXT
          },
          {
            field: 'ownerType',
            required: true,
            filter: true,
            column: 4,
            type: TYPE.DROPDOWN,
            options: () => this.ownerTypes
          },
          {
            field: 'ownerState',
            required: true,
            filter: true,
            column: 4,
            type: TYPE.DROPDOWN,
            options: () => this.ownerStates
          },
          {
            field: 'clearingOrganization',
            required: true,
            column: 4,
            type: TYPE.TEXT
          }]
      }];
  }

  protected initData() {
    super.initData();

    this.settingsFormLoadingProgressValue = 0;
    this.commonFieldService.getOwners(FieldRequest.DEFAULT()).subscribe(fieldResult => {
      this.owners = fieldResult.records ? [...this.getFields(fieldResult)] : [];
      this.settingsFormLoadingProgressValue += 100 / 2;
    });

    this.commonFieldService.getExchangeCodes(FieldRequest.DEFAULT()).subscribe(fieldResult => {
      this.exchanges = fieldResult.records ? [...this.getFields(fieldResult)] : [];
      // let defaultAllExchange = FieldRecord.DEFAULT();
      // defaultAllExchange.text = this.translateService.instant('page.account.form.defaultExchangeAll');
      // defaultAllExchange.id = ExchangeDetail.ALL;
      // this.exchanges.unshift(defaultAllExchange);
      this.settingsFormLoadingProgressValue += 100 / 2;
    });

    this.ownerTypes = [];
    for (let key in OwnerCode.OwnerType) {
      this.ownerTypes.push(new FieldRecord(key, key.toLowerCase()))
    }

    this.ownerStates = [];
    for (let key in OwnerCode.OwnerState) {
      this.ownerStates.push(new FieldRecord(key, key.toLowerCase()))
    }
  }

  onFormShow() {
  }
}
